define(function (require) {
  const Marionette = require('backbone.marionette');
  const ViewManager = require('civicsUtils/view_manager');
  const IpsModel = require('civicsBase/ipsModel');
  const invitation_model = require('civicsModels/portal/invitation_model');
  const constants = require('civicsUtils/constants');
  const utils = require('civicsUtils/general_utilities');
	const ConfirmationModal = require('civicsViews/core/confirmation/v_itv_confirmation');

  const tpl = require('civicsViews/InviteApplicant/templates/t_itv_invite_notifications.hbs');
  return Marionette.ItemView.extend({
    className: 'notification-view',
    tagName: 'div',
    template: tpl,
    events: {
      'click .accept-invite-link': 'acceptInvite',
      'click .login-return-link': 'loginRedirectPage',
      'click .create-profile-link': 'registerRedirectPage',
      'click @ui.btnClose': 'closeClicked'
      },
    ui:{
      linkAccept: '.accept-invite-link',
      inviteNotification: '.invite-notification',
      notifications: '.rhythm-notifications',
      btnClose: '.close-button'
    },

    initialize: function(options) {
      this.config = options.config;
      this.notificationRegion = options.notificationRegion;
      this.config.userName = App.user.userName; // need to display username for invite notification
      this.config.intDetailTargetPage = this.config.instrumentDetailsLink.urlPath({intdetails:this.config.invitecdrType,intid:this.config.inviteInstID});
      this.config.id = this.config.inviteKey;
      this.modalRegion = options.modalRegion;
    },
    onShow: function() {

    },
    onRender: function() {
      this.$el.rhythmCivicsTooltipInit();
      this.$el.rhythmThemeInit();
      this.$el.rhythmThemeInitCivics();
    },
    acceptInvite: function() {
      var modelToAccept = new invitation_model();
      var decode = decodeURIComponent(this.config.inviteCode);
      modelToAccept.invitationCode = decode;
      modelToAccept.id = this.config.id;
      modelToAccept.acceptedDateTime = constants.DATE_TIME_MIN_VAL;
      var payload = { 'id':  this.config.id, 'acceptedDateTime': constants.DATE_TIME_MIN_VAL, 'invitationCode': decode};
      var self = this;
      modelToAccept.save(payload, {
         type: 'PUT',
         success: function (model, response, options) {
           App.sessionStorage.remove('CIVICS', 'INVITE_RECORD');
           self.recordRedirectPage();
         },
         error: function (model, response, options) {
          if(response && response.responseJSON && response.responseJSON.responseStatus && response.responseJSON.responseStatus.errorCode == "409"){
              var modal = new ConfirmationModal({
							title: i18n.t('CIVICS.COMMON.NOTIFICATION'),
							okLabel: i18n.t('CIVICS.COMMON.OK'),
							message: i18n.t('CIVICS.COMMON_INVITE_APPLICANT.ALREADY_ADDED'),
							modalRegion: self.modalRegion,
							showCancelButton: false,
							okCallback: () => {self.recordRedirectPage()},
							closeCallback: () => {self.recordRedirectPage()}
						  });
            self.closeClicked();
						self.modalRegion.show(modal);
						self.modalRegion.showModal();
						
					 }
					 else
              ViewManager.openAlert(i18n.t('CIVICS.INVITE.ERROR_ACCEPTING_INVITE'));
         },
       });
       ViewManager.resetErrorMessages(this); //should not append error messages

    },
    recordRedirectPage: function (){
      var urlParams = App.params.get() || {};
      if ( urlParams.intid && urlParams.intdetails) {
        window.location.reload();   // reload if in instrument details(window.location won't work in mozilla/ie if redirecting to the same path)
      } else {
        window.location.href = this.config.intDetailTargetPage; // redirect to instrument details
      }
    },
    registerRedirectPage: function (){
      window.location.href = this.config.registerUserPage;
    },
    loginRedirectPage: function (){
      if (this.config.ssoURL) {
				window.location.assign(this.config.ssoURL);
				return false;
			}
      else {
        window.location.href = this.config.loginRedirectPage;
      }
    },
    closeClicked:function(){
      if(this.notificationRegion) {
        this.destroy();
      }
    },
    templateHelpers: function() {
      var self = this;
      var userName = this.config.userName;
      if(userName != undefined){
        this.config.isUserLoggedIn = true;
      } else {
        this.config.isUserLoggedIn = false;
      }
      return {
        userName: this.config.userName,
        isUserLoggedIn: this.config.isUserLoggedIn,
        usesSSO: this.config.usesSSO,
        textExpiredOn: function (){
          if (self.config.expiredDate && self.config.expiredDate.includes(constants.DATE_TIME_MIN_VAL)){
            return "";
          } else {
            return i18n.t('CIVICS.INVITE.PUBLIC_VIEW_MESSAGE_EXPIRE_ON')+ Handlebars.helpers["global:formatDate"](self.config.expiredDate);
          }
        }
      }
    }
	});
});
